// // import { Button, CircularProgress, Paper, Stack, Typography } from "@mui/material";
// // import { toast } from "react-toastify";

// // const FinalTabContent = ({ productData, onBack, onSubmit, loading, isEditMode }) => {

// //     const handleSubmit = async () => {
// //         try {
// //             if (!productData?.images || productData?.images?.length === 0) {
// //                 toast.error("Please add at least one primary image");
// //                 return;
// //             }

// //             if (!productData?.variants || productData?.variants?.length === 0) {
// //                 toast.error("Please add at least one variant");
// //                 return;
// //             }

// //             if (!productData?.attributes || productData?.attributes?.length === 0) {
// //                 toast.error("Please add at least one attribute");
// //                 return;
// //             }
// //             console.log("final tab data :", productData)

// //             await onSubmit(productData);
// //         } catch (error) {
// //             toast.error("Failed to create product");
// //         }
// //     };

// //     return (
// //         <Paper
// //             elevation={0}
// //             sx={{
// //                 p: { xs: 2, md: 4 },
// //                 borderRadius: 3,
// //                 backgroundColor: "#fafafa",
// //                 border: "1px solid #eee",
// //                 textAlign: "center"
// //             }}
// //         >
// //             {/* Text */}
// //             <Typography variant="h5" fontWeight={600} mb={2}>
// //                 Ready to Create Product?
// //             </Typography>

// //             <Typography variant="body1" color="text.secondary" mb={4}>
// //                 Please review all the details. Once submitted, the product
// //                 will be saved in the database.
// //             </Typography>

// //             {/* Centered Buttons */}
// //             <Stack
// //                 direction={{ xs: "column", sm: "row" }}
// //                 spacing={2}
// //                 justifyContent="center"
// //                 alignItems="center"
// //             >
// //                 <Button
// //                     variant="outlined"
// //                     onClick={onBack}
// //                     disabled={loading}
// //                     sx={{
// //                         borderRadius: 2,
// //                         textTransform: "none",
// //                         minWidth: 140
// //                     }}
// //                 >
// //                     Back
// //                 </Button>

// //                 <Button
// //                     variant="contained"
// //                     onClick={handleSubmit}
// //                     disabled={loading}
// //                     sx={{
// //                         borderRadius: 2,
// //                         textTransform: "none",
// //                         minWidth: 160
// //                     }}
// //                 >
// //                     {loading ? (
// //                         <CircularProgress size={22} color="inherit" />
// //                     ) : (
// //                         isEditMode ? "Update Product" : "Create Product"
// //                     )}
// //                 </Button>
// //             </Stack>
// //         </Paper>
// //     );
// // };

// // export default FinalTabContent;


// import { useState } from "react";
// import {
//     Button,
//     CircularProgress,
//     Paper,
//     Stack,
//     Typography,
//     Grid,
//     Box,
//     Chip
// } from "@mui/material";
// import { toast } from "react-toastify";

// const FinalTabContent = ({
//     productData,
//     size,
//     publicCategory,
//     color,
//     onBack,
//     onSubmit,
//     loading,
//     isEditMode
// }) => {

//     const [selectedVariantIndex, setSelectedVariantIndex] = useState(0);

//     const handleSubmit = async () => {

//         if (!productData?.imagesMeta?.length) {
//             toast.error("Please add at least one primary image");
//             return;
//         }

//         if (!productData?.variants?.length) {
//             toast.error("Please add at least one variant");
//             return;
//         }

//         if (!productData?.attributes?.length) {
//             toast.error("Please add at least one attribute");
//             return;
//         }

//         await onSubmit(productData);
//     };

//     return (
//         <Paper
//             sx={{
//                 p: 4,
//                 borderRadius: 3,
//                 backgroundColor: "#fafafa",
//                 border: "1px solid #eee"
//             }}
//         >

//             {/* ================= PREVIEW SECTION ================= */}
//             <Grid container spacing={4} mb={5}>

//                 {/* LEFT IMAGE */}
//                 <Grid item xs={12} md={4}>
//                     <Box
//                         sx={{
//                             borderRadius: 3,
//                             overflow: "hidden",
//                             border: "1px solid #ddd",
//                             height: 220,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             backgroundColor: "#fff"
//                         }}
//                     >
//                         {productData.images.find(img => img.isPrimary)?.preview ? (
//                             <img
//                                 src={productData.images.find(img => img.isPrimary)?.preview}
//                                 alt="Product"
//                                 style={{
//                                     maxWidth: "100%",
//                                     maxHeight: "100%",
//                                     objectFit: "contain"
//                                 }}
//                             />
//                         ) : (
//                             <Typography>No Image</Typography>
//                         )}
//                     </Box>
//                 </Grid>

//                 {/* RIGHT DETAILS */}
//                 <Grid item xs={12} md={7}>
//                     <Stack spacing={2}>

//                         <Typography variant="h6" color="text.secondary">
//                             Brand: {productData?.brandName || "-"}
//                         </Typography>

//                         <Typography variant="h6" fontWeight={600}>
//                             {productData?.title || "Product Title"}
//                         </Typography>

//                         {/* PRICE */}
//                         <Typography variant="h5" fontWeight={700}>
//                             ₹ {productData?.variants?.[selectedVariantIndex]?.price || 0}
//                         </Typography>

//                         {/* COLOR */}
//                         <Typography variant="h6" fontWeight={700}>
//                             Color: {color?.colors?.response?.find((c) => c.id === productData?.colorId)?.name}
//                         </Typography>

//                         {/* SIZE SELECTOR */}
//                         <Stack direction="row" spacing={1} flexWrap="wrap">
//                             {productData?.variants?.map((variant, index) => (
//                                 <Chip
//                                     key={variant.id || variant.tempId || index}
//                                     label={size?.sizes?.response?.find(
//                                         s => s.id === variant.sizeId
//                                     )?.name
//                                     }
//                                     clickable
//                                     color={
//                                         selectedVariantIndex === index
//                                             ? "primary"
//                                             : "default"
//                                     }
//                                     onClick={() =>
//                                         setSelectedVariantIndex(index)
//                                     }
//                                 />
//                             ))}
//                         </Stack>

//                         <Typography variant="body2">
//                             {productData?.description?.slice(0, 120) || "No description"}
//                         </Typography>

//                     </Stack>
//                 </Grid>
//             </Grid>

//             {/* ================= ACTION BUTTONS ================= */}
//             <Stack
//                 direction={{ xs: "column", sm: "row" }}
//                 spacing={2}
//                 justifyContent="center"
//                 alignItems="center"
//             >
//                 <Button
//                     variant="outlined"
//                     onClick={onBack}
//                     disabled={loading}
//                     sx={{ borderRadius: 2, minWidth: 140 }}
//                 >
//                     Back
//                 </Button>

//                 <Button
//                     variant="contained"
//                     onClick={handleSubmit}
//                     disabled={loading}
//                     sx={{ borderRadius: 2, minWidth: 160 }}
//                 >
//                     {loading ? (
//                         <CircularProgress size={22} color="inherit" />
//                     ) : (
//                         isEditMode ? "Update Product" : "Create Product"
//                     )}
//                 </Button>
//             </Stack>
//         </Paper>
//     );
// };

// export default FinalTabContent;
import React, { useMemo, useState } from "react";
import {
    Button,
    CircularProgress,
    Paper,
    Stack,
    Typography,
    Grid,
    Card,
    CardMedia,
    ToggleButton,
    ToggleButtonGroup,
    Divider,
    Box
} from "@mui/material";
import { toast } from "react-toastify";

const FinalTabContent = ({
    productData,
    size,
    categories,
    color,
    onBack,
    onSubmit,
    loading,
    isEditMode
}) => {

    const [selectedSizeId, setSelectedSizeId] = useState(
        productData?.variants?.[0]?.sizeId || null
    );

    // Primary Image
    const primaryImage = useMemo(() => {
        return productData?.images?.find(img => img.isPrimary)
            || productData?.images?.[0];
    }, [productData?.images]);

    // Selected Variant
    const selectedVariant = useMemo(() => {
        return productData?.variants?.find(
            v => v.sizeId === selectedSizeId
        ) || productData?.variants?.[0];
    }, [selectedSizeId, productData?.variants]);

    // Category Hierarchy Safe
    const categoryText = useMemo(() => {
        const mainCat = categories?.categories?.response?.find(
            c => c.id === productData?.categoryId
        );

        const subCat = mainCat?.subCategories?.find(
            sc => sc.id === productData?.subCategoryId
        );

        const productCat = subCat?.productCategories?.find(
            pc => pc.id === productData?.productCategoryId
        );

        return [mainCat?.name, subCat?.name, productCat?.name]
            .filter(Boolean)
            .join(" > ");
    }, [categories, productData]);

    const handleSubmit = async () => {
        try {
            if (!productData?.images?.length) {
                toast.error("Please add at least one image");
                return;
            }

            if (!productData?.variants?.length) {
                toast.error("Please add at least one variant");
                return;
            }

            if (!productData?.attributes?.length) {
                toast.error("Please add at least one attribute");
                return;
            }

            await onSubmit(productData);
        } catch (error) {
            toast.error("Failed to submit product");
        }
    };

    return (
        <Paper
            sx={{
                p: { xs: 2, md: 4 },
                borderRadius: 3,
                border: "1px solid #eee",
                backgroundColor: "#fafafa"
            }}
        >
            <Grid container spacing={4} alignItems="center">

                {/* LEFT - IMAGE */}
                <Grid item xs={12} md={4}>
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Card
                            sx={{
                                borderRadius: 3,
                                boxShadow: 3,
                                maxWidth: 300,
                                width: "100%"
                            }}
                        >
                            <CardMedia
                                component="img"
                                image={
                                    primaryImage?.preview ||
                                    primaryImage?.imageUrl ||
                                    "https://via.placeholder.com/400"
                                }
                                alt="Primary"
                                sx={{
                                    height: { xs: 280, md: 300 },
                                    objectFit: "cover"
                                }}
                            />
                        </Card>
                    </Box>
                </Grid>

                {/* RIGHT - DETAILS */}
                <Grid item xs={12} md={8}>
                    <Stack spacing={2}>

                        <Typography variant="body2" color="text.secondary">
                            Brand: <b>{productData?.brandName || "-"}</b>
                        </Typography>

                        <Typography variant="h6" fontWeight={600}>
                            {productData?.title}
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            Category: {categoryText}
                        </Typography>

                        <Divider />

                        {/* Price */}
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 700,
                                color: "#1976d2"
                            }}
                        >
                            ₹ {selectedVariant?.price || 0}
                        </Typography>

                        {/* Color */}
                        <Typography variant="body2">
                            Color:{" "}
                            <b>
                                {color?.colors?.response?.find(
                                    c => c.id === productData?.colorId
                                )?.name || "-"}
                            </b>
                        </Typography>

                        {/* Sizes */}
                        <Stack spacing={1}>
                            <Typography variant="body2">
                                Available Sizes:
                            </Typography>

                            <ToggleButtonGroup
                                exclusive
                                value={selectedSizeId}
                                onChange={(e, val) => {
                                    if (val) setSelectedSizeId(val);
                                }}
                                size="small"
                                sx={{
                                    flexWrap: "wrap",
                                    gap: 1
                                }}
                            >
                                {productData?.variants?.map((variant) => (
                                    <ToggleButton
                                        key={variant.sizeId}
                                        value={variant.sizeId}
                                        sx={{
                                            borderRadius: 2,
                                            px: 2
                                        }}
                                    >
                                        {
                                            size?.sizes?.response?.find(
                                                s => s.id === variant.sizeId
                                            )?.name
                                        }
                                    </ToggleButton>
                                ))}
                            </ToggleButtonGroup>
                        </Stack>

                        <Divider />

                        {/* Description */}
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                lineHeight: 1.6
                            }}
                        >
                            {productData?.description?.slice(0, 250)}
                        </Typography>

                    </Stack>
                </Grid>

            </Grid>

            {/* ACTION BUTTONS */}
            <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                justifyContent="center"
                mt={5}
            >
                <Button
                    variant="outlined"
                    onClick={onBack}
                    disabled={loading}
                    sx={{ minWidth: 140 }}
                >
                    Back
                </Button>

                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={loading}
                    sx={{ minWidth: 160 }}
                >
                    {loading ? (
                        <CircularProgress size={22} color="inherit" />
                    ) : (
                        isEditMode ? "Update Product" : "Create Product"
                    )}
                </Button>
            </Stack>
        </Paper>
    );
};

export default FinalTabContent;